'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { OVERVIEW_EXPERIMENT_COOKIE } from '~/constants/cookies';

/**
 * The A/B arm assigned by proxy.ts: 'intermediate' or 'direct'. `undefined` means no arm is known —
 * either before mount (the cookie may still say either arm) or for anyone never enrolled, e.g. the US.
 * That is not the control arm: 'direct' is. Both render the pre-experiment flow, but only 'direct'
 * belongs in the comparison.
 *
 * In an effect, not render: the landing page is statically prerendered, so reading the cookie during
 * render would mismatch hydration.
 */
export function useOverviewExperimentVariant() {
  const $ = _c(2);
  const [variant, setVariant] = useState();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const match = new RegExp(`(?:^|; )${OVERVIEW_EXPERIMENT_COOKIE}=([^;]*)`).exec(globalThis.document?.cookie ?? "");
      setVariant(match ? decodeURIComponent(match[1]) : undefined);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return variant;
}